import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  wrapperProprtyInfoCard: {
    display: "flex",
    flexDirection: "row",
    gap: "32px",
    padding: "24px",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  containerLeftImage: {
    width: "432px",
    height: "662px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      height: "800px",
    },
    [theme.breakpoints.down("xs")]: {
      height: "365px",
      width: "100%",
    },
  },
  containerInfoProp: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "23px",
  },
  dividerPropInfo: {
    marginBottom: "24px",
    marginTop: "8px",
  },
  containerPropInfoDetails: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  containerLeftDetails: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  containerInfoItem: {
    display: "flex",
    flexDirection: "row",
    gap: "16px",
    alignItems: "start",
    [theme.breakpoints.down(321)]: {
      flexDirection: "column",
    },
  },
  containerInfoItem: {
    display: "flex",
    flexDirection: "row",
    gap: "16px",
    alignItems: "start",
    [theme.breakpoints.down(321)]: {
      flexDirection: "column",
    },
  },
  containerRightDetails: {
    display: "flex",
    flexDirection: "row",
    gap: "16px",
  },
  containerLocationValue: {
    display: "flex",
    flexDirection: "row",
    gap: "5px",
  },
  divider: {
    marginTop: "8px",
  },
  containerAreaInformation: {
    display: "flex",
    flexDirection: "row",
    gap: "32px",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
    [theme.breakpoints.down(1025)]: {
      flexWrap: "wrap",
    },
  },
  containerImages: {
    marginTop: "15px",
    display: "flex",
    flexDirection: "row",
    gap: "12px",
    [theme.breakpoints.down(769)]: {
      flexDirection: "column",
      flexWrap: "wrap",
    },
    [theme.breakpoints.down(1025)]: {
      flexWrap: "wrap",
    },
  },
  containerImageItem: {
    height: "120px",
    display: "flex",
    width: "186.5px",
  },
}));
